import React from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings } from "react-icons/tb";
function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
}) {
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const getTypeName = (type) => {
    switch (type) {
      case 3:
        return "Работодателям";
      case 4:
        return "СПО/ВПО";
      case 5:
        return "Студентам";
      case 6:
        return "Абитуриентам";
      default:
        return "Тип не определен";
    }
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "10%",
    },
    {
      name: <span className="font-weight-bold fs-13">Заголовок</span>,
      selector: (row) => row.Title,
      sortable: true,
      width: "25%",
    },
    {
      name: <span className="font-weight-bold fs-13">Описание</span>,
      selector: (row) => row.Description,
      sortable: true,
      width: "30%",
    },
    {
      name: <span className="font-weight-bold fs-13">Тип</span>,
      selector: (row) => getTypeName(row.IdType),
      sortable: true,
      width: "15%",
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => {
                  toggleModal(cellProps);
                }}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      progressComponent={<ClipLoader />}
      progressPending={load}
      paginationTotalRows={total}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      pagination
      paginationServer
      paginationComponentOptions={paginationOptions}
    />
  );
}

export default Table;
